var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-more", attrs: { name: "app_more", id: "app_more" } },
    _vm._l(_vm.appMore, function(item) {
      return _c("div", { key: item.title, class: item.class }, [
        _c("div", { staticClass: "am-block dp-f" }, [
          _c("div", { staticClass: "block-content" }, [
            _c("h3", { staticClass: "block-title" }, [
              _vm._v(_vm._s(item.title))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "block-subtitle" }, [
              _vm._v(_vm._s(item.subTitle))
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "block-use nutstore1" },
              _vm._l(item.texts1, function(text, index) {
                return _c(
                  "li",
                  { key: text, style: _vm.generateStyle(item.icons1, index) },
                  [_vm._v("\n\t\t\t\t\t\t" + _vm._s(text) + "\n\t\t\t\t\t")]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "block-pic",
            attrs: { src: item.src1 || _vm.pic1, alt: "" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "am-block dp-f reverse" }, [
          _c("img", {
            staticClass: "block-pic",
            attrs: { src: item.src2 || _vm.pic2, alt: "" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "block-content" }, [
            _c(
              "ul",
              { staticClass: "block-use nutstore2" },
              _vm._l(item.texts2, function(text, index) {
                return _c(
                  "li",
                  { key: text, style: _vm.generateStyle(item.icons2, index) },
                  [_vm._v("\n\t\t\t\t\t\t" + _vm._s(text) + "\n\t\t\t\t\t")]
                )
              }),
              0
            )
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }